/* 單獨列傳：周瑜傳（設計見 docs/CAMPAIGN-ZHOUYU.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「zhouyu_」，免得和其他列傳撞名。 */
// @ts-nocheck
import zhouyu1 from '../story/zhouyu1.ts';
import zhouyu2 from '../story/zhouyu2.ts';
import zhouyu3 from '../story/zhouyu3.ts';
import zhouyu3b from '../story/zhouyu3b.ts';
import zhouyu4 from '../story/zhouyu4.ts';
import liyang from '../maps/zhouyu_liyang.ts';
import yiling from '../maps/zhouyu_yiling.ts';
import nanjun from '../maps/zhouyu_nanjun.ts';

export default {
  list: { id: 'zhouyu', name: '周瑜傳', years: '195–210', parts: [
    { name: '孫策篇', chapters: ['zhouyu-1'] },
    { name: '赤壁篇', chapters: ['zhouyu-2'] },
    { name: '南郡篇', chapters: ['zhouyu-3', 'zhouyu-4'] },
  ] },
  chapters: [zhouyu1, zhouyu2, zhouyu3, zhouyu3b, zhouyu4],
  maps: { zhouyu_liyang: liyang, zhouyu_yiling: yiling, zhouyu_nanjun: nanjun },
};
